/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import ASSET_PATHS from "../../../assets/config/assetPaths";
import { useNavigate } from "react-router-dom";
// import { useSwipeable } from "react-swipeable";
import SubmitWorkOrderModal from "../Modal/SubmitWorkOrder";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { ImSpinner2 } from "react-icons/im";
import { submitInspectionData } from "../../../redux/slices/workOrderSlice";
import { WorkOrderStatus } from "../../../types/workOrder";

interface WorkOrderCardProps {
    id: number;
    order: any;
    isOnline: boolean;
}

const WorkOrderCard: React.FC<WorkOrderCardProps> = ({ id, order, isOnline }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { items } = useSelector(
        (state: RootState) => state.pendingUploadsQueue
    );
    const matchWorkOrderPending = items.some((item: any) => item.workOrderId === id);

    const navigate = useNavigate();
    const { token } = useSelector((state: RootState) => state.auth);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSubmitWorkOrderModalOpen, setIsSubmitWorkOrderModalOpen] = useState(false);
    
    const [showIcon, _] = useState(false);

    const handleCardClick = () => {
        navigate(`/work-orders/${id}`);
    };

    const handleCloseSubmitWorkOrderModal = () => {
        setIsSubmitWorkOrderModalOpen(false);
    };

    // const handlers =
    //     order?.workOrderStatus == WorkOrderStatus.Completed
    //         ? useSwipeable({
    //             onSwipedLeft: () => setShowIcon(true),
    //             onSwipedRight: () => setShowIcon(false),
    //             preventScrollOnSwipe: true,
    //             trackMouse: true,
    //         })
    //         : {};

    const handleSubmitWorkOrder = async () => {
        try {
            setIsLoading(true)
            const submitResult = await dispatch(submitInspectionData({ token, inspectionData: {}, workOrder_ID: id }));

            if (submitResult.meta.requestStatus === "fulfilled") {
                handleCloseSubmitWorkOrderModal();
            } else {
                setIsLoading(false);
                console.log("Failed to to submit work order", submitResult);
            }
        } catch (err: any) {
            console.log('Login failed:', err);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div
            className={`rounded-xl flex justify-between cursor-pointer transition-all duration-300`}
        >
            <div className={`${showIcon && "bg-primary"}rounded-xl w-full`}>
                <div
                    // {...handlers}
                    className={`relative p-4 shadow-card-shadow w-full ${!showIcon && "rounded-xl"
                        } bg-white flex justify-between h-full cursor-pointer transition-all duration-300 ${showIcon ? "translate-x-[-80px]" : "translate-x-0"
                        }`}
                    onClick={handleCardClick}
                >
                    {showIcon && (
                        <div className="bg-red absolute right-[-50px] top-1/2 transform -translate-y-1/2 flex items-center">
                            <img src={ASSET_PATHS.cloudUploadWhite} alt="Delete Icon" className="h-8 w-8" />
                        </div>
                    )}

                    <div className="flex flex-col gap-3">
                        <div className="flex items-center gap-2">
                            <img src={ASSET_PATHS.id} alt="Menu Icon" className="h-5 w-5" />
                            <p className="text-lg font-bold text-black">{id}</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <img src={ASSET_PATHS.title} alt="Title" className="h-5 w-5" />
                            <p className="text-sm text-gray-700">{order?.accountName}</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <img src={ASSET_PATHS.packageBlueIcon} alt="Package" className="h-6 w-6" />
                            <p className="text-sm text-gray-700">{order?.package_Name}</p>
                        </div>
                        <div className="flex items-start gap-2 max-w-[80%]">
                            <img src={ASSET_PATHS.location} alt="Location" />
                            <p className="text-sm text-gray-500">{order?.address}</p>
                        </div>

                    </div>

                    <div className="p-4">
                        <div className="flex flex-col items-end gap-2 absolute top-4 right-3">
                            {order?.workOrderStatus === WorkOrderStatus.InProgress && (
                                <div className="bg-orange-500 px-2 py-[0.99px] rounded-full text-xs font-medium text-white flex gap-1">
                                    <img src={ASSET_PATHS.tablerProgressWhite} alt={WorkOrderStatus.InProgress} />
                                    {`Items ${order?.completedAssetCount || 0}/${order?.assetCount || 0}`}
                                </div>
                            )}
                            {order?.workOrderStatus === WorkOrderStatus.Completed && (
                                <div className="bg-green-500 px-2 py-[0.99px] rounded-full text-xs font-medium text-white flex gap-1">
                                    <img src={ASSET_PATHS.checkCircleWhite} width={"16"} height={"16"} alt={WorkOrderStatus.Completed} />
                                    {`Items ${order?.completedAssetCount || 0}/${order?.assetCount || 0}`}
                                </div>
                            )}
                            {order?.workOrderStatus === WorkOrderStatus.Scheduled && (
                                <div className="bg-primary px-2 py-[0.99px] rounded-full text-xs font-medium text-white flex gap-1">
                                    <img src={ASSET_PATHS.calendarWhite} alt={WorkOrderStatus.Scheduled} />
                                    {`Items ${order?.completedAssetCount || 0}/${order?.assetCount || 0}`}
                                </div>
                            )}
                        </div>

                        <div
                            className="flex flex-col items-end gap-2 absolute bottom-4 right-3"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {
                                (isOnline && order?.assetCount == order?.completedAssetCount && order?.assetCount > 0 && order?.workOrderStatus !== WorkOrderStatus.Completed && items?.length == 0 && !matchWorkOrderPending)
                                && (
                                    <div className="mt-auto flex text-primary text-sm items-center font-semibold gap-1">
                                        {isLoading ? <ImSpinner2 className="animate-spin mr-2" /> :
                                            <>
                                                <img src={ASSET_PATHS.clipboardCheck} alt="Clipboard Check" />
                                                <button onClick={() => setIsSubmitWorkOrderModalOpen(true)}>
                                                    Submit
                                                </button>
                                            </>
                                        }
                                    </div>
                                )
                            }
                            {order?.workOrderStatus === WorkOrderStatus.InProgress && order?.isUploading && (
                                <div className="mt-auto flex text-primary text-sm items-center font-semibold gap-1">
                                    <img src={ASSET_PATHS.cloudUpload} alt="Upload" /> Uploading
                                </div>
                            )}
                            {order?.workOrderStatus === WorkOrderStatus.InProgress && order?.isRetrying && (
                                <div className="mt-auto flex text-red-400 text-sm items-center font-semibold gap-1">
                                    <img src={ASSET_PATHS.refresh} alt="Retry" /> Retry
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {
                isSubmitWorkOrderModalOpen && (
                    <SubmitWorkOrderModal
                        isOpen={isSubmitWorkOrderModalOpen}
                        onClose={handleCloseSubmitWorkOrderModal}
                        onConfirm={handleSubmitWorkOrder}
                    />
                )
            }
        </div>
    );
};

export default WorkOrderCard;
